module.exports = __webpack_public_path__ + "img/water_drop.f0a8cf90.svg";